module.exports = __webpack_public_path__ + "static/assets/e856e10ea83d2383f39ec9b6ba70115f.png";